import React from 'react';
import CategoryQuotaDetails from './CategoryQuotaDetails';

const NationalQuotaSummary = ({ quota }) => (
  <>
    <dl className="mb-[18px] mt-1 grid grid-cols-3 gap-4">
      {[
        ['Total', quota.total],
        ['Occupées', quota.occupied],
        ['Disponibles', quota.available],
      ].map(([label, value]) => (
        <div key={label}>
          <dt className="text-[13px] text-slate-500">{label}</dt>
          <dd className={`mt-1.5 text-3xl font-semibold ${label === 'Disponibles' ? 'text-emerald-700' : ''}`}>
            {value.toLocaleString('fr-FR')}
          </dd>
        </div>
      ))}
    </dl>
    <div className="h-2.5 overflow-hidden rounded-[3px] bg-slate-100" aria-hidden="true">
      <div
        className="h-full bg-emerald-600"
        style={{ width: `${quota.total ? Math.min(100, (quota.occupied / quota.total) * 100) : 0}%` }}
      />
    </div>
    <div className="mt-1 flex justify-between gap-2 text-xs text-slate-500">
      <span>
        {quota.total
          ? `${((quota.occupied / quota.total) * 100).toLocaleString('fr-FR', {
              maximumFractionDigits: 1,
              minimumFractionDigits: 1,
            })} % occupé`
          : '—'}
      </span>
      {quota.available <= 0 && <strong className="text-red-700">Quota atteint</strong>}
    </div>
    <div className="mt-4">
      {quota.categories.map((category) => (
        <CategoryQuotaDetails key={category.id} category={category} className="border-t py-3 last:pb-0" />
      ))}
    </div>
  </>
);
export default NationalQuotaSummary;
